import { toast } from "react-toastify";
export class NotifyService {
  successNotitifcation(message: string) {
    toast.success(message, {
      position: toast.POSITION.TOP_RIGHT
    });
  }

  errorNotitifcation(message: string) {
    toast.error(message, {
      position: toast.POSITION.TOP_RIGHT
    });
  }
}
